import { makeReducerPermission } from "../../index";

export const requestEmailChangePermission = makeReducerPermission({
  reducerName: "requestEmailChange",
});
